import * as React from 'react';

import { ConnectedAboutModal } from './components/AboutModal';
import actionCreators from './service/AboutModal.actions';
import { ABOUT_MODAL_REDUCER_KEY, aboutModalReducer } from './service/AboutModal.reducer';
import { aboutModalSaga } from './service/AboutModal.saga';

export { showAboutModal } from './service/AboutModal.actions';

export interface AboutModalRootComponentProps {
	children: React.ReactElement;
}

export function AboutModalRootComponent({
	children,
}: AboutModalRootComponentProps): React.ReactElement {
	return (
		<>
			<ConnectedAboutModal />
			{children}
		</>
	);
}

export const AboutModalModule = {
	id: 'tdc:aboutModal',
	actionCreators,
	saga: aboutModalSaga,
	RootComponent: AboutModalRootComponent,
	reducer: {
		inventory: {
			[ABOUT_MODAL_REDUCER_KEY]: aboutModalReducer,
		},
	},
};
export { ConnectedAboutModal };
